module.exports = "././img/fontawesome-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ../~/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 833
// module chunks = 0